module.exports = __webpack_public_path__ + "media/לוח.bb977669.mp3";